var projectTimeline = {
	"Project timeline": "Сроки реализации проекта",
	"None planned": "Ничего не планируется",
	"1-3 months": "От 1 до 3 месяцев",
	"4-6 months": "От 4 до 6 месяцев",
	"7-12 months": "От 7 до 12 месяцев",
	"More than 1 year": "Более 1 года"
};

export { projectTimeline as default };
